/**
 * Thin PostHog wrapper.
 * PostHog is loaded globally via /public/index.html (window.posthog).
 * This helper guards against missing instance (SSR, blockers, dev).
 */

const getPH = () => {
  if (typeof window === "undefined") return null;
  return window.posthog && typeof window.posthog.capture === "function"
    ? window.posthog
    : null;
};

/**
 * Track a named event with optional properties.
 * Safe to call even if PostHog is blocked / not loaded.
 */
export const track = (eventName, properties = {}) => {
  try {
    const ph = getPH();
    if (!ph) return;
    ph.capture(eventName, {
      ...properties,
      $current_url: typeof window !== "undefined" ? window.location.href : undefined,
    });
  } catch (e) {
    // never break the app on analytics failure
    if (typeof console !== "undefined" && console.debug) {
      console.debug("[analytics] capture failed:", e);
    }
  }
};
